<dx-data-grid
  style="width: 100%"
  keyExpr="id"
  [dataSource]="order$ | async"
  [masterDetail]="{ enabled: true, template: 'detailTemplate' }"
  [showBorders]="true"
  [hoverStateEnabled]="true"
  [columnMinWidth]="60"
  stylingMode="outlined"
  [allowColumnResizing]="true"
  [allowColumnReordering]="true"
  (onRowClick)="rowCick($event)"
  noDataText="{{ 'ORDER_NOT_FOUND' | translate }}"
  class="data-grid-responsive data-grid-orders"
  (onOptionChanged)="changeResaltViewTemplate($event)">
  <dxo-column-chooser [enabled]="true" mode="dragAndDrop"></dxo-column-chooser>

  <dxo-selection mode="single"></dxo-selection>

  <dxo-paging [pageSize]="15"></dxo-paging>

  <dxo-pager [showInfo]="true" infoText="{{ 'PAGINATOR_ORDER' | translate }}"></dxo-pager>

  <dxo-group-panel [visible]="true"></dxo-group-panel>

  <dxo-grouping [autoExpandAll]="true"></dxo-grouping>

  <dxo-header-filter [visible]="true" alignment="center"></dxo-header-filter>

  <dxi-column
    dataField="createDate"
    caption="{{ 'DATE_CREATE' | translate }}"
    [width]="140"
    cellTemplate="createDateTemplate"
    [visible]="this.getVisibilityForColumn(0)"
    cssClass="createDate"></dxi-column>

  <dxi-column
    dataField="category.value"
    caption="{{ 'TYPE' | translate }}"
    [width]="70"
    cellTemplate="orderTypeTemplate"
    [visible]="this.getVisibilityForColumn(1)"
    cssClass="serviceType"></dxi-column>

  <dxi-column
    dataField="id"
    caption="{{ 'ORDER_CODE' | translate }}"
    [width]="125"
    cellTemplate="orderIdTemplate"
    [visible]="this.getVisibilityForColumn(2)"
    cssClass="dataId"></dxi-column>

  <dxi-column
    [calculateCellValue]="calcServiceCategoryName"
    [allowSorting]="true"
    [allowFiltering]="true"
    caption="{{ 'IT_SERVICE_CATEGORY' | translate }}"
    [visible]="this.getVisibilityForColumn(3)"
    cssClass="category"></dxi-column>

  <dxi-column
    dataField="title"
    caption="{{ 'THEME' | translate }}"
    cellTemplate="orderTitleTemplate"
    [visible]="this.getVisibilityForColumn(4)"></dxi-column>

  <dxi-column
    dataField="lastComment"
    caption="{{ 'LAST_ACTION' | translate }}"
    cellTemplate="lastActionTemplate"
    [visible]="this.getVisibilityForColumn(5)"></dxi-column>

  <dxi-column
    dataField="employeeFor.fio"
    caption="{{ 'FOR_WHOM' | translate }}"
    cellTemplate="forWhomTemplate"
    [visible]="this.getVisibilityForColumn(6)"></dxi-column>

  <dxi-column
    dataField="status.value"
    caption="{{ 'STATUS' | translate }}"
    [width]="200"
    cellTemplate="statusTemplate"
    [visible]="this.getVisibilityForColumn(7)"></dxi-column>

  <dxi-column
    dataField="getTimeLeft(order.data)"
    caption="{{ 'WILL_BE_DONE' | translate }}"
    [width]="150"
    cellTemplate="timeLeftTemplate"
    [visible]="this.getVisibilityForColumn(8)"></dxi-column>

  <dxi-column dataField="sort" caption="SORT" sortOrder="desc" [visible]="false" [showInColumnChooser]="false"></dxi-column>

  <!-- createDateTemplate -->
  <div *dxTemplate="let order of 'createDateTemplate'">
    <span class="order-data-border" [ngStyle]="{ 'border-left-color': getColorByStatus(order.data.status.id) }"></span>
    <label style="display: none">від</label>
    {{ order.data.createDate | date: 'dd-MM-yyyy' }}
  </div>

  <!-- orderTypeTemplate -->
  <div *dxTemplate="let order of 'orderTypeTemplate'">
    @if (order.data.category?.id === 1) {
      <img [title]="order.data.category?.value" style="width: 20px; height: 20px" src="/assets/images/icon_zayavka.png" />
    }
    @if (order.data.category?.id === 2) {
      <img [title]="order.data.category?.value" style="width: 20px; height: 20px" src="/assets/images/icon_incident.png" />
    }
  </div>

  <!-- orderIdTemplate -->
  <div *dxTemplate="let order of 'orderIdTemplate'">
    <label style="display: none">№ заявки</label>
    {{ order.data.id }}
  </div>

  <!-- orderTitleTemplate -->
  <div *dxTemplate="let order of 'orderTitleTemplate'" class="theme">
    <label style="display: none">Тема</label>
    {{ order.data.title }}
  </div>

  <!-- lastActionTemplate -->
  <div *dxTemplate="let order of 'lastActionTemplate'" class="lastAction">
    @if (order.data.lastComment) {
      <label style="display: none">Остання дія</label>
    }
    {{ order.data.lastComment }}
  </div>

  <!-- forWhomTemplate -->
  <div *dxTemplate="let order of 'forWhomTemplate'" class="forWhom">
    <label style="display: none">Для кого</label>
    {{ order.data.employeeFor?.fio }}
  </div>

  <!-- statusTemplate -->
  <div *dxTemplate="let order of 'statusTemplate'" class="status">
    <label style="display: none">Статус</label>
    <span
      class="order-status-name"
      [ngStyle]="{
        'background-color': getBackgroundColorByStatus(order.data.status.id),
        color: getColorByStatus(order.data.status.id),
      }">
      {{ order.data.status.name }}
    </span>
  </div>

  <!-- timeLeftTemplate -->
  <div *dxTemplate="let order of 'timeLeftTemplate'" class="willBeDone">
    @if (order.data.orderTime) {
      <label style="display: none">Буде виконано</label>
    }
    <div [ngClass]="getClassForTimeLeft(order.data)" class="order-status-done text-nowrap">
      @if (order.data.orderTime > 0) {
        <div class="order-status-time">
          <span>{{ getTimeLeft(order.data) }}</span>
        </div>
      }
      @if (order.data.orderTime > 0) {
        <div class="order-status-icon-block">
          <span [class]="getIconClass(order.data)"></span>
        </div>
      }
    </div>
  </div>

  <!-- detailTemplate  -->
  <div *dxTemplate="let order of 'detailTemplate'">
    <app-order-detail-for-grid [order]="order.data" [categoryName]="this.getServiceCategoryName(order.data)"></app-order-detail-for-grid>
  </div>
</dx-data-grid>
